(function (root) {
  'use strict';
  var keys = ['oppref', 'campaign_id', 'ad_group_id', 'ad_id', 'ad_account_id', 'openai_ad_account', 'utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'utm_id'];
  var storageKey = 'mataunion_ads_first_touch_v1';
  function clean(value, key) {
    return typeof value === 'string' && value.length > 0 && value.length <= (key === 'oppref' ? 2048 : 256) && !/[\x00-\x1f\x7f{}]/.test(value) ? value : null;
  }
  function parse(search) {
    var params = new URLSearchParams(search), values = {}, issues = [];
    keys.forEach(function (key) {
      var all = params.getAll(key);
      if (all.length > 1) issues.push('duplicate:' + key);
      values[key] = all.length && all.every(function (v) { return v === all[0]; }) ? clean(all[0], key) : null;
      if (all.length && !values[key]) issues.push('invalid:' + key);
    });
    var eligible = !!values.oppref || (String(values.utm_source).toLowerCase() === 'chatgpt' && String(values.utm_medium).toLowerCase() === 'paid');
    function mapped(primary, alias) {
      if (params.has(primary)) {
        if (values[primary] && values[alias] && values[primary] !== values[alias]) issues.push('conflict:' + primary);
        return values[primary];
      }
      return values[alias];
    }
    var utm = {};
    keys.filter(function (k) { return k.indexOf('utm_') === 0; }).forEach(function (k) { utm[k] = values[k]; });
    return { issues: issues, candidate: eligible ? {
      source: 'chatgpt', medium: values.utm_medium || null, oppref: values.oppref,
      campaign_id: mapped('campaign_id', 'utm_campaign'), ad_group_id: mapped('ad_group_id', 'utm_term'),
      ad_id: mapped('ad_id', 'utm_content'), ad_account_id: mapped('ad_account_id', 'openai_ad_account'), utm: utm
    } : null };
  }
  function valid(record, now) {
    if (!record || record.schema_version !== 1 || record.model !== 'first_openai_touch' || !/^[a-f0-9-]{36}$/i.test(record.attribution_id || '')) return false;
    var start = Date.parse(record.landing_timestamp), end = Date.parse(record.expires_at);
    if (!Number.isFinite(start) || !Number.isFinite(end) || start > now + 60000 || end <= now || end <= start || end - start > 90 * 86400000) return false;
    if (record.source !== 'chatgpt' || typeof record.first_landing_page !== 'string') return false;
    try { var url = new URL(record.first_landing_page); if (!/^https?:$/.test(url.protocol) || url.search || url.hash || url.username || url.password) return false; } catch (_) { return false; }
    if (!record.utm || typeof record.utm !== 'object') return false;
    return ['oppref', 'campaign_id', 'ad_group_id', 'ad_id', 'ad_account_id', 'medium'].every(function (k) {
      return record[k] === null || !!clean(record[k], k);
    }) && Object.keys(record.utm).every(function (k) { return keys.indexOf(k) >= 0 && k.indexOf('utm_') === 0 && (record.utm[k] === null || !!clean(record.utm[k], k)); });
  }
  function create(candidate, page, arrivedAt, now, days, id) {
    return Object.assign({}, candidate, {
      schema_version: 1, attribution_id: id, model: 'first_openai_touch', first_landing_page: page,
      landing_timestamp: new Date(arrivedAt).toISOString(), consent_granted_at: new Date(now).toISOString(),
      expires_at: new Date(arrivedAt + Math.min(90, Math.max(1, Number(days) || 30)) * 86400000).toISOString()
    });
  }
  var api = { parse: parse, valid: valid, create: create, storageKey: storageKey };
  if (typeof module === 'object' && module.exports) module.exports = api;
  else root.MataunionAttribution = api;
})(typeof window !== 'undefined' ? window : globalThis);
